import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';

import { Grid } from '@mui/material';
import { Button, Switch, Tooltip, Icons, Select } from '@gpstrackit/gtc-react-controls';

import { ContactsSelector } from 'Components';
import Preferences from 'Core/containers/Preferences';
import { validateJsonObject } from '../../../../../../core/data/Helpers';

//Actions
import {
    catalogLoad
} from 'Redux/actions';

const RouteAlertWatchers = (props) => {

    const { setFormData, formData } = props
    const { messages, locale } = useIntl();

    const [listAlertEvents, setListAlertEvents] = useState([]);

    const contacts = useSelector(state => state.catalogsRedux.contacts);
    const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);

    const loading = useSelector(state => state.routesTemplatesAlertWatchers?.loading);
    const alertEvents = useSelector(state => state.routesTemplatesAlertWatchers?.alertEvents);

    //Refs
    const preferencesRef = useRef();

    const dispatch = useDispatch();
    //const [formData, setFormData] = useState({ ...ROUTES_NEW_ALERTWATCHERS_FORM });
    const [country, setCountry] = useState(null);

    useEffect(() => {
        if(alertEvents?.length > 0){
            setListAlertEvents(alertEvents.map((x) => { 
                return { 
                    ...x, 
                    name: messages[`fsmRoute_alertWatchers_route_events_${x.code}`] ? messages[`fsmRoute_alertWatchers_route_events_${x.code}`] : messages['fsmRoute_alertWatchers_route_events_noevent']
                }}
            ));
        }
    }, [alertEvents, locale])

    useEffect(() => {
        dispatch(catalogLoad(['contacts']));
        //clearForm()
    },[])

    const handleClose = () => {
        //dispatch(etaCreateEditReset());
        setCountry(null);
        //setFormData({});
        //clearForm();
    }

    const addEtaWatchers = () => {
        const combinedList = [...formData?.alertSubscribers, ...formData?.etaData?.contactsEta].reduce((acc, current) => {
            if (!acc.some(item => item.id === current.id)) {
                acc.push(current);
            }
            return acc;
        }, []);
        setFormData(formData => ({ ...formData, alertSubscribers: combinedList }));
    }

    return(
        <div>
            <Preferences
                ref={preferencesRef}
                preferencesKey="etaLink"
                onInitialPreferences={(preferences) => {
                    if (preferences?.country) {
                        setCountry(preferences?.country);
                    }
                }}
            >
                <Grid
                    container
                    wrap="nowrap"
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    sx={{ gridGap: 30 }}
                >
                    <Grid item>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label className={'labelMapSettings'} style={{ fontWeight: 600 }}>
                                {messages['fsmRoute_alertWatchers_route_alert']}
                            </label>
                            <div style={{ paddingLeft: 5}}>
                                <Tooltip
                                    placement="bottom"
                                    title={messages['fsmRoute_alertWatchers_route_alert_info']}
                                >
                                    <Icons
                                    
                                    name="help"
                                    //name="info"
                                    size="medium"
                                    />
                                </Tooltip>
                            </div>
                        </div>
                        <Switch 
                            checked={formData?.alert || false} 
                            optionLabels={[messages['yes'], messages['no']]}
                            size="large"
                            labelPosition="right"
                            onChange={(value) => {
                                setFormData(formData => ({ ...formData, alert: value }));
                        }}/>
                    </Grid>
                </Grid>
                { 
                    formData?.alert 
                    && 
                    <Grid
                        container
                        wrap="nowrap"
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        sx={{ gridGap: 25 }}
                    >
                        <Grid item style={{ width: '100%', paddingLeft: 5, paddingTop: 10 }}>
                            <Grid>
                                <label>{messages['fsmRoute_alertWatchers_route_events']}:</label><label style={{ color: 'red' }}>*</label>
                            </Grid>
                            <Select 
                                name="alertSelect"
                                textField="name"
                                valueField="code"
                                placeholder={messages['fsmRoute_alertWatchers_route_events_select']}
                                isMulti={true}
                                options={listAlertEvents || []}
                                isDisabled={false}
                                isLoading={loading}
                                isClearable={true}
                                isSearchable={true}
                                showPillsOutside={true}
                                value={listAlertEvents?.length && formData?.alertTypeCodes ? listAlertEvents.filter((x) => formData?.alertTypeCodes.includes(x.code)) : []}
                                onChange={(value) => {
                                    setFormData(formData => ({ ...formData, alertTypeCodes: value?.length > 0 ? value.map((x) => x.code) : [] }));   
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <h3>{messages['fsmRoute_alertWatchers_route_recipients']}</h3>
                        </Grid>
                        <Grid>
                            <label>{messages['fsmRoute_alertWatchers_route_info']}</label>
                        </Grid>
                        <Grid item>
                            <div>
                                <label className={'labelMapSettings'} style={{ fontWeight: 400 }}>
                                    {messages['fsmRoute_alertWatchers_route_recipientscopy']}
                                </label>
                                <div style={{ paddingTop: 10 }}>

                                    <Button
                                        onClick={(e) => {
                                            if (e) e.preventDefault();
                                            //remove the marker
                                            addEtaWatchers()
                                        }}
                                        style={{ whiteSpace: 'nowrap' }}
                                        variant="green"
                                        >
                                        {messages['fsmRoute_alertWatchers_route_copy']}
                                    </Button>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} style={{ width: '100%'}}>
                            <div
                                id='divEtaLink'
                                style={{
                                    width: '100%',
                                    maxWidth: '100%',
                                    height: '100%',
                                    boxSizing: 'border-box'
                                }}
                            >
                                <ContactsSelector
                                    label={messages['eta_choose_contact']}
                                    values={formData?.alertSubscribers}
                                    //disabled={loading || (create?.id ? true : false)}
                                    required
                                    styleMax
                                    showLabel
                                    loading={loadingContacts}
                                    country={country}
                                    contacts={contacts?.map(contact => {
                                        return { ...contact, name: contact?.title }
                                    })}
                                    entities={["EMAIL", "SMS", "CONTACT"]}
                                    emailKeyPress={(e) => { e.code === 'Space' && e.preventDefault(); }}
                                    onChange={(values) => {
                                        setFormData({ ...formData, alertSubscribers: values });
                                    }}
                                    onChangeCountry={(newCountry) => {
                                        preferencesRef?.current?.savePreference("User", "etaLink", { country: newCountry?.code });
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                }
            </Preferences>
        </div>
    )

}

export default RouteAlertWatchers